import { render, staticRenderFns } from "./SidebarWrapper.vue?vue&type=template&id=8d7cd154&scoped=true"
import script from "./SidebarWrapper.vue?vue&type=script&lang=js"
export * from "./SidebarWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7cd154",
  null
  
)

export default component.exports